module.exports = __webpack_public_path__ + "img/thumb_shops_mins_landing_page.2de90cb6.jpg";